import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { toggleTheme } from "../redux/slices/themeSlice";
import {  Moon } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";
import { Sun } from "../SVGComponents";

export default function ThemeToggle() {
  const dispatch = useDispatch();
  const theme = useSelector((state: any) => state.theme.theme);

  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
  }, [theme]);

  return (
    <button onClick={() => dispatch(toggleTheme())}>
      <AnimatePresence mode="wait" initial={false}>
        {theme === "dark" ? (
          <motion.div
            key="sun"
            initial={{ opacity: 0, rotate: -90 }}
            animate={{ opacity: 1, rotate: 0 }}
            exit={{ opacity: 0, rotate: 90 }}
            transition={{ duration: 0.3 }}
          >
            <Sun
              // size={20}
              // className="text-white hover:text-themeGreen dark:hover:text-[#d7a407]"
            />
          </motion.div>
        ) : (
          <motion.div
            key="moon"
            initial={{ opacity: 0, rotate: 90 }}
            animate={{ opacity: 1, rotate: 0 }}
            exit={{ opacity: 0, rotate: -90 }}
            transition={{ duration: 0.3 }}
          >
            <Moon
              size={22}
              className="text-[#237249] dark:hover:text-[#d7a407]"
            />
          </motion.div>
        )}
      </AnimatePresence>
    </button>
  );
}
